import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Box} from 'reactjs-admin-lte'
import {Pagination,Button,ButtonToolbar,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl,Form,OverlayTrigger,Tooltip} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import PullStock from '../../component/element/PullStock'
import IframeModal from '../../component/element/IframeModal'
import CKAutocomplete from '../../component/element/CKAutocomplete'
import AutopartStore from '../../stores/AutopartStore'
import WorkdocStore from '../../stores/WorkdocStore'
import ReportStore from '../../stores/ReportStore';
import Moment from 'moment';
import SupplierPageModal from '../po/SupplierPageModal'
// import Select from 'react-select'
import {connect} from 'react-redux'
import Select from 'react-select'
import DatePicker from 'component/element/DatePicker'
import './Stock.css'
import _ from 'lodash'

var NotificationSystem = require('react-notification-system');
const DEFAULT_ROW = 10
class StockRequestDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this.car_info_timestmap = Date.now()
  }

  initState(newState){
    
    let state = {
      activePage:1,
      totalPage:1,
      cur_data:[],
      pullStockShow:false,
      loading:false,
      showHistory:false,
      mpNo:'',      
      showNotice:false,
      shopName:'',
      rowBeep:-1,
      data:this.newEmptyRow(DEFAULT_ROW),
      options:[],
      doc:this.getEmptyDoc(),
      input:{car_registration_no:'',response_by:'',request_by:''},
      car_registration_no_list:[],
      stockApproverList:[],
      customerList:[],
      car_info:'',
      showSupplier:false,
      validQu:[],
      validDoc:{request_by:{formValid:null,validState:null},response_by:{formValid:null,validState:null}},
      isSave:true
    }

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }


  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.doc!==undefined){
      if(newProps.doc.recordid!==''){
        //console.log('onRe',newProps.doc)    
        let car_info = newProps.doc.brand+'/'+newProps.doc.model
        if (newProps.doc.brand===undefined||newProps.doc.model===undefined)
          car_info = ''

        this.setState({doc:newProps.doc,car_info:car_info})
      }else{
        //console.log('onEmptyDoc')
        this.setState({doc:this.getEmptyDoc(),car_info:'',data:this.newEmptyRow(DEFAULT_ROW)})        
      }
      
    }

    if(newProps.show && newProps.show!==this.props.show){
      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()
      if(newProps.doc.recordid!==''){
        this.loadData(newProps.doc.recordid)
      }
    }
  }
  
  getToday(){
    return Moment().format('L LT').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543);
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  loadCarRegistrationNo(doc) {
    let that = this
    let car = []
    if(doc.car_registration_no!==undefined && doc.car_registration_no.length>=2 && (Date.now() - that.car_info_timestmap)>2000){
      StockStore.loadCarRegistrationNo(doc.car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        that.setState({car_registration_no_list:car})
        that.car_info_timestmap = Date.now()
      })
    }
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  subscribeDocChannel(channel){
         
  }

  renameDoc(newSoNo){
    let {doc} = this.state
    
    this.setState({mpNo:newSoNo,doc:doc})
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {container_quantity:'',container_unit:'',is_container:'0',quantity_per_container_unit:'',unit_type:'unit',itemnum:'',productcode:'',description:'',quantity:'',in_stock_quantity:'',stock_type:'',unit:'',reason:'',code_options:[]}
    })
  }

  getEmptyDoc(){
    return {work_no:'',description:'',doc_no:'',description:'',response_by:'',request_by:'',recordid:'',shop_name:'',shop_id:'',bu_name:'',desired_date:''}
  }

  handleSelect(pageSelect) { 
    let {cur_data} = this.state
    if (cur_data.length > 10) {
      let data = []
      let end = (pageSelect * 20) - 1
      let start = end - 19
      for (var i=start;i<=end;i++) {
        if (i<cur_data.length) {
          data.push(cur_data[i])
        }
      }
      this.setState({activePage:pageSelect, data:data})
    }
  }

  loadData(mpNo) {
    
    let that = this
    this.setState({ loading: true, mpNo: mpNo })
    StockStore.loadRecordDoc(mpNo, function (result) {
      let data = result.data
      data = data.map((item,index)=>{
        item = Object.assign({unit_type:'unit'},item)
        return item
      })
      if (result.data.length < DEFAULT_ROW) {
        data = data[0].itemlist.concat(that.newEmptyRow(DEFAULT_ROW - result.data.length))
      }
      ReactDOM.findDOMNode(that.pcInput[result.data.length]).focus();
      that.pcInput = new Array(data.length).fill('')
      that.setState({ loading: false,  data: data })
    })
  }

  onPrintClick(){
    let {soNo} = this.state
    if (process.env.NODE_ENV === "development") {
        window.open('https://demo-fast.bigfix.co/sriracha/pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }else{
        window.open('./pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }
  }

  onCustomerClick(){
    this.setState({showSupplier:true})
  }

  onInputChange(key,e){
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onCustomerPageSelect(item){
    let {doc} = this.state
    doc['customer_id'] = item.customer_id
    doc['customer_name'] = item.name
    doc['customer_address'] = item.address
    this.setState({doc:doc})
  }

  onDateChange(value){
    let {doc} = this.state
    doc['added_date'] = value
    this.setState({doc:doc})
  }

  onExportClick(){

  }

  onSaveClick(){
    let {doc,data} = this.state
    this.saveStockRequest(doc,data)  
  }

  saveStockRequest(doc,data){
    let {validQu,validDoc,isSave} = this.state
    let {messages} = this.props
    if (isSave) {
      this.setState({isSave:false})
      let added_date = doc.doc_date
      if (added_date!==''&&added_date!==null&&added_date!==undefined) {
        let year = parseInt(added_date.substring(0,4)) + 543
        let month = added_date.substring(5,7)
        let day = added_date.substring(8,10)
        let time = added_date.substring(11,16)
        added_date = day + '/' + month + '/' + year + ' ' + time
      } else {
        added_date = this.getToday()
      }

      if (doc.request_by===''||doc.request_by===null||doc.request_by===undefined) {
        validDoc.request_by.formValid = 'formValidationError1'
        validDoc.request_by.validState = 'error'
        this.setState({validDoc:validDoc,isSave:true})
        return false
      }

      if (doc.response_by===''||doc.response_by===null||doc.response_by===undefined) {
        validDoc.response_by.formValid = 'formValidationError1'
        validDoc.response_by.validState = 'error'
        this.setState({validDoc:validDoc,isSave:true})
        return false
      }  

      this.setState({loading:true})    

      let itemList = []
      let checkEmptyAll = true
      data.forEach(function(item,index) {
        if (item.description!=='') {
          checkEmptyAll = false
        }
      })

      if (checkEmptyAll) {
          this.setState({loading:false,isSave:true})
          this._notificationSystem.addNotification({
            title:messages['Notice'],
            message: messages['Fill Request PO'],
            level: 'error',
            position:'tc'
          });
      } else {
        let is_valid = false
        let is_qty_0 = false
        this.setState({loading:false})
        data.forEach(function(item,index) {
          if (item.description!==''&&item.quantity!==''&&item.quantity!==null&&item.quantity!==undefined) {
            if ((item.quantity*1)<=0) {
              is_qty_0 = true
              validQu[index] = true
              is_valid = true
            } else {
              itemList.push(item)
            }  
          } else if (item.description!==''&&(item.quantity===''||item.quantity===null||item.quantity===undefined)) {
            validQu[index] = true
            is_valid = true
          }
        })

        if (is_valid) {
            this.setState({validQu:validQu,loading:false,isSave:true})
            if (is_qty_0) {
              this._notificationSystem.addNotification({
                title:messages['Notice'],
                message: messages['Request PO More 0'],
                level: 'error',
                position:'tc'
              });
            }
        } else {
          let postData = {item:itemList, meta:{description:doc.description,request_by:doc.request_by, response_by:doc.response_by, 
            car_registration_no:doc.car_registration_no, wo:doc.work_no, bu_name:doc.bu_name, desired_date:doc.desired_date,   
            stock_type:'any', record_type:'request_purchase', added_date:added_date, shop_id:doc.shop_id, shop_name: doc.shop_name}}
            
          StockStore.requestPurchaseProduct('any', postData, (result)=>{
              if (result.status == 'OK') {                
                doc.doc_no = result.id
                doc.recordid = result.id
                this.setState({loading:false,doc:doc,validQu:[],isSave:true})
                this._notificationSystem.addNotification({
                  title:messages['Notice'],
                  message: messages['Request PO Successfully'],
                  level: 'info',
                  position:'tc'
                });
              }
          },(error)=>{
            this.setState({loading:false,isSave:true})
            this._notificationSystem.addNotification({
              title:messages['Notice'],
              message: messages['Request PO Fail'],
              level: 'error',
              position:'tc'
            });
          })
        }
      }
    }  
  }

  onCloseClick(){
    let {validDoc} = this.state
    validDoc.request_by.formValid = null
    validDoc.request_by.validState = null
    validDoc.response_by.formValid = null
    validDoc.response_by.validState = null
    this.setState({validQu:[],validDoc:validDoc})
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  getTotalPage() {
    let {cur_data} = this.state
    let totalPage = cur_data.length / 20
    totalPage = Math.round(totalPage)
    this.setState({totalPage:totalPage})
  }
  
  onDeleteRowClick(index){ 
    let {data,cur_data,validQu} = this.state
    validQu[index] = false
    cur_data.splice(index,1);
    data.splice(index,1);
    this.setState({data:data, cur_data:cur_data,validQu:validQu})    
  }

  summaryAmount(data){
    let amount = 0
    data.map((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {doc,data,validQu} = this.state
    let value = e.target.value
    data[index][key] = value
    validQu[index] = false
    if(['end_quantity','begin_quantity'].includes(key)){
      data[index]['in_stock_quantity'] = (data[index]['begin_quantity']*1 - data[index]['end_quantity']*1).toFixed(2)
    } else if (key==='productcode') {
      if (data[index][key].length>=3) {
        this.onSearchProductCode(index,data[index][key])
      } else if (data[index][key]==='') {
        data[index].code_options = []
      }
    }
    this.setState({doc:doc,data:data,validQu:validQu})
  }

  onFormSelect(index,field,e,item_select) {
    let {data} = this.state
    if (field==='productcode') {
      data[index] = Object.assign(data[index],_.pick(item_select,['itemnum','productcode','unit','quantity_per_container_unit','stock_type','is_container','container_quantity','container_unit']),{description:item_select.detail,quantity:'',in_stock_quantity:item_select.quantity})
    } else {
      data[index][field] = e
    }
    this.setState({data:data})
  }

  onSearchProductCode(index,query) {
    let {data} = this.state

    StockStore.loadSearchAnyProductCode(query,  (result)=> {
      let options = result.data.map((item,index)=>{
        return Object.assign(_.pick(item,['productcode','itemnum','quantity','unit','quantity_per_container_unit','stock_type','is_container','container_quantity','container_unit']),
        {
          detail:item.description,
          label:item.productcode+' - '+item.description+(item.cat_name!==''&&item.cat_name!==null&&item.cat_name!==undefined?' (หมวด'+item.cat_name+')':''),
          value:item.productcode            
        })   
      })
      
      data[index].code_options = options
      this.setState({data:data})
    });

    
  }

  onRowAdd(number){
    let {data} = this.state
    data = data.concat(this.newEmptyRow(number))
    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  }

  onSearch(index, query) {
    
    StockStore.loadSearchAnyProductDetail(query,  (result)=> {
      let options = result.data.map((item, index) => {
        return Object.assign(_.pick(item,['itemnum','unit','stock_type','container_quantity','container_unit','is_container','quantity_per_container_unit']),
        { 
          id: item.itemnum, 
          productCode: item.productcode ,
          categoryName: item.cat_name, 
          detail: item.description, 
          pricePerUnit: item.price_per_unit, 
          quantity:'',
          in_stock_quantity:item.quantity,
        }
          );        
      })
      this.setState({ options: options })
    })
  }

  // onTypeaheadBlur(index){
  //   let {data} = this.state
  //   if (data[index].itemnum==''||data[index].itemnum==null||data[index].itemnum==undefined)
  //     data[index].description = ''
  //   this.setState({data:data})
  // }

  onTypeaheadChange(index,option){
    let {data} = this.state
    if(option.length===1){
      data[index] = Object.assign(data[index],_.pick(option[0],['unit','productcode','in_stock_quantity','stock_type','container_quantity','container_unit','is_container','quantity_per_container_unit'],{unit_type:'unit',description:option[0].detail}))
      if(option[0].itemnum){
        data[index].itemnum = option[0].itemnum
        data[index].productcode = option[0].productCode
      }
    }

    this.setState({data:data})
  }

  onTypeaheadInputChange(index,query){
    let {data} = this.state
    data[index]['description'] = query
    this.setState({data:data})
  }

  onTextKeyPress(index,key,target) {
    if(target.charCode==13){
      this.onSaveClick()
    }
  }

  onDesiredDateChange(e) {
    let {doc} = this.state
    doc.desired_date = e
    this.setState({doc:doc})
  }

  onSearchCarKeyPress(e) {
    if (e.charCode === 13) {
      let {doc} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          doc.work_no =  item.work_no         
          doc.car_registration_no = item.car_registration_no              
          that.setState({doc:doc,car_info:item.car_info})
          // that._description.focus()
        }else{
          doc.work_no = ''
          doc.car_registration_no = '';
          that.setState({doc:doc,car_info:that.props.messages['Car registration Not Found']})
        }
      })
    }
  }

  onSearchKeyPress(index,key,target) {
    if(target.charCode===13){
      let {data} = this.state
      let {messages} = this.props
      let that = this,foundIndex = -1
      let productcode = data[index][key];
      
      data.map((item,iindex)=>{
        if(item.productcode===productcode && iindex!==index){
          foundIndex = iindex
        }
      })
      if(foundIndex>=0){
        
        data[index].productcode = ''
        
      }else{
        this.setState({loading:true})
        
        AutopartStore.loadStockProductCode('any',productcode,function(result){
          //console.log(result)
          //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
          if(result.data.length>0){
            let item = result.data[0]                           
            data[index].productcode = item.productcode
            data[index].unit = item.unit
            data[index].description = item.description
            data[index].in_stock_quantity = item.quantity
            data[index].stock_type = item.stock_type
            data[index].itemnum = item.itemnum
            data[index].container_quantity = item.container_quantity
            data[index].container_unit = item.container_unit
            data[index].is_container = item.is_container
            data[index].quantity_per_container_unit = item.quantity_per_container_unit
            data[index].unit_type = 'unit'
            if(index===data.length-1){
              //End index
              data = data.concat(that.newEmptyRow(1))
              that.pcInput[index+1] = ''
            }
            that.setState({loading:false,data:data})
            ReactDOM.findDOMNode(that.pcInput[index+1]).focus();
            
          }else{
            data[index].productcode = ''
            that.setState({loading:false,data:data})
            that._notificationSystem.addNotification({
              title:messages['Notice'],
              message: messages['Serial No Not Found']+' '+productcode+' '+messages['In Warehouse'],
              level: 'warning',
              position:'tc'
            });
          }
        })      
      }
      this.setState({data:data,rowBeep:foundIndex})
        setTimeout(function(){ 
          that.setState({rowBeep:-1})
        }, 1500);
    }
    
  }


  onMenuItemSelect(index){
    if('clearlist'===index){
      this.setState({clearShow:true})
    }else if("adjuststock"===index){
      this.setState({stockShow:true})      
    }else if("print"===index){
      let url = ''
      if (process.env.NODE_ENV === "development") {
        url  = './?startPage=PrintReportStockCheck&type='+this.props.stockType
      } else{
        url = './pdf/v2/?startPage=PrintReportStockCheck&type='+this.props.stockType
      }
      this.refs.iframe.loadUrl(url)
    }else if ("pullstock"===index) {
      this.setState({pullStockShow:true})
    }
  }

  onConfirmStockClear(){
    this.setState({clearShow:false,data:this.newEmptyRow(DEFAULT_ROW)})
    this.saveStockCheck([])
  }

  onConfirmStockSave(){
    let {data} = this.state 
    let that = this
    let {messages} = this.props
    StockStore.requestStockAdjust(this.props.stockType,data,function(result){
      data = data.map((item,index)=>{
        item.stock_quantity = item.quantity
        return item
      })
      that.setState({stockShow:false,data:data})
      that._notificationSystem.addNotification({
        title:messages['Notice'],
        message: messages['Adjust Quantity Of Warehouse'],
        level: 'info',
        position:'tc'
      });
    },function(){
      that.setState({stockShow:false})
    })
  }

  onTextBlur(index,e) {
    let {data} = this.state
    let that = this
    that.setState({loading:false})
    StockStore.loadMixpaintItemcode(data[index].productcode,e.target.value,function(result) {
      if (result.data.length>0) {
        data[index].last_quantity = result.data[0].end_quantity
      } else {
        data[index].last_quantity = ''
      }
      that.setState({data:data,loading:false})
    })
  }

  onDataChange(cat_id) {
    let that = this
    let {messages} = this.props
    ReportStore.loadStockList(this.props.stockType, "", cat_id, "", "", "", function(result) {
      let data = result.data.map((item,index)=>{
        item.stock_quantity = item.quantity
        item.quantity = ''
        item.detail = item.description
        return item
      })

      if(data.length <10) {
        data = data.concat(that.newEmptyRow(10-data.length))
        that.setState({data:data, totalPage:1})
        that.saveStockCheck(data)
      } else {
        let all_data = data
        let totalPage = all_data.length / 20
        totalPage = Math.round(totalPage)
        if (totalPage > 1) {
          data = []
          for (var i=0;i<20;i++) {
            data.push(all_data[i])
          }
        } else {
          totalPage = 1
        }
        that.setState({data:data, totalPage:totalPage, cur_data:all_data})
        that.saveStockCheck(all_data)
      }

      that._notificationSystem.addNotification({
        title:messages['Notice'],
        message: messages['Pull Data Successfully'],
        level: 'info',
        position:'tc'
      });
    })
  }

  getValidationState() {
    const length = this.state.shopName.length;
    if (length > 10) return 'success';
    else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let quantityTitle = ''
    let {messages} = this.props
    if(option.quantity>0){
      quantityTitle = ' '+messages['Have Number']+' '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} ({messages['Category']}{option.categoryName}) - {option.pricePerUnit} {messages['Bath']} {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }


  renderRemark(){
    let {description} = this.state.doc
    return (
      <Row>
      <Col md={3}>
        <FormGroup
          controlId="formBasicText"
          validationState={this.getValidationState()}
        >
          <ControlLabel>{this.props.messages['Remark']} </ControlLabel>
          <InputGroup>            
            <FormControl value={description} componentClass="textarea" style={{width:'400px',height:'150px'}}
             onChange={this.onInputChange.bind(this,'description')}/>            
          </InputGroup>            
        </FormGroup>
      </Col>
      </Row>
    )
  }

  getRowClassName(item,index){
    
    return ''
  }

  onHideClick(e) {
    this.setState({pullStockShow:e})
  }

  onPrintClick(){
    let {doc} = this.state
    if (process.env.NODE_ENV === "development") {
      window.open('https://demo2.bigfix.co/korat/pdf/?sr='+doc.recordid+'&file=stockrecord_doc', '_blank');
    } else{
      window.open('./pdf/?sr='+doc.recordid+'&file=stockrecord_doc', '_blank');
    }
  
  }

  onHeadInputChagne(field,e){
    let {doc} = this.state
    doc[field] = e.target.value

    this.setState({doc:doc})
  }

  onUnitChange(index,item,e) {
    let {data} = this.state
    data[index].unit_type = e.value
    // if (e.value==='unit')
    //   data[index].unit = data[index].unit
    // else
    //   data[index].unit = data[index].container_unit
    this.setState({data:data})
  }

  renderRowData(){
    let {data,options,validQu} = this.state
    let {messages} = this.props
    return(
      data.map((item,index)=>{
        let qty_in = (<span>{item.in_stock_quantity}</span>)
        if (item.is_container==='1') {
          if (item.unit_type==='unit') {
            qty_in = (item.in_stock_quantity===''||item.in_stock_quantity===null||item.in_stock_quantity===undefined||isNaN(item.in_stock_quantity)?0:item.in_stock_quantity)
          } else {
            let _qty = (item.in_stock_quantity===''||item.in_stock_quantity===null||item.in_stock_quantity===undefined||isNaN(item.in_stock_quantity)?0:item.in_stock_quantity)
            let _qty_per_container_unit = (item.quantity_per_container_unit===''||item.quantity_per_container_unit===null||item.quantity_per_container_unit===undefined||isNaN(item.quantity_per_container_unit)?0:item.quantity_per_container_unit)
            qty_in = _qty/_qty_per_container_unit
          }
          qty_in = this.getNumberFormat(qty_in)
        } else {
          if ((item.in_stock_quantity===undefined||item.in_stock_quantity===null||item.itemnum==='')&&item.description!=='') {
            let tooltip = (<Tooltip id='stock-request-doc'>
              <strong>รายการนี้ไม่มีในคลัง</strong>
            </Tooltip>)
            qty_in = (<OverlayTrigger placement="right" overlay={tooltip}>
              <FontAwesome name='question' />
            </OverlayTrigger>)
          }
        }  
        return(
          <tr key={index} className={this.getRowClassName(item,index)}>
            <td className='text-center'>{index+1}</td>
            <td className='data-column'>
              {/* <FormControl className='text-left' 
              ref={(input) => { this.pcInput[index] = input; }} 
              value={item.productcode} 
              onChange={this.onFormChange.bind(this,index,'productcode')}
              onKeyPress={this.onSearchKeyPress.bind(this,index,'productcode')}
              /> */}
              <CKAutocomplete
                  top='-34px'
                  ref={(input) => { this.pcInput[index] = input; }}
                  items={item.code_options}
                  value={item.productcode}
                  onChange={this.onFormChange.bind(this,index,'productcode')}
                  onSelect={this.onFormSelect.bind(this,index,'productcode')}
                  shouldItemRender={null}
              />
            </td>        
            <td className='data-column'>
              <AsyncTypeahead
                allowNew={true}
                multiple={false}
                newSelectionPrefix={messages['Add New Item']+' : '}
                promptText={messages['Keypress For Searching']}
                searchText={messages['Searching']}
                // emptyLabel={messages['Item Not Found']+' : '+item.description}
                selected={[{ detail: item.description }]}
                options={options}
                labelKey="detail"
                onSearch={this.onSearch.bind(this, index)}
                onChange={this.onTypeaheadChange.bind(this, index)}
                onInputChange={this.onTypeaheadInputChange.bind(this,index)}
                // onBlur={this.onTypeaheadBlur.bind(this, index)}
                placeholder=""
                renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
              />
            </td>
            <td className='data-column text-center'>
              <FormControl 
                type="number" 
                step="0.5" 
                className='text-center' 
                value={item.quantity} 
                onChange={this.onFormChange.bind(this,index,'quantity')}
                style={{border:validQu[index]?'1px solid #d9534f':''}}        
              />
            </td>
            <td className='text-center' style={{verticalAlign:'middle'}}>
              {qty_in}
            </td>
            <td className={item.is_container==='1'?'text-left':'text-center'}>
              {item.is_container==='1'?
              <Select
                clearable={false}
                value={item.unit_type}
                options={[{label:item.unit+' (หน่วยย่อย)',value:'unit'},{label:item.container_unit+' (หน่วยใหญ่)',value:'container_unit'}]}
                onChange={this.onUnitChange.bind(this,index,item)}
              />
              :item.itemnum===''||item.itemnum===null||item.itemnum===undefined?
              <FormControl 
                className='text-center' 
                value={item.unit} 
                onChange={this.onFormChange.bind(this,index,'unit')}    
              />
              :item.unit}
            </td>
            <td className='data-column text-center'>
              <FormControl 
                value={item.reason} 
                onChange={this.onFormChange.bind(this,index,'reason')}
              />
            </td>
            <td className='text-center'><Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='close'/></Button></td>
          </tr>
        )
      })
    )  
  }


  renderTable(){
    let {messages} = this.props
    return (
      <div className='table-responsive'>
      <table className='table table-hover table-bordered-solid' style={{marginBottom:'0',minWidth:'1280px'}}>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
            <th className='text-center' style={{width:'180px'}}>{messages['Barcode/Product Code']}</th>
            <th className='text-center' style={{width:'400px'}}>{messages['Item Name']}</th>
            <th className='text-center' style={{width:'100px'}}>{messages['Quantity']}</th>     
            <th className='text-center' style={{width:'100px'}}>{messages['Quantity Stock']}</th>     
            <th className='text-center' style={{width:'150px'}}>{messages['Unit']}</th>   
            <th className='text-center' style={{width:'200px'}}>{messages['Reason']}</th>       
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr >            
            <th colSpan={3} className='text-right'>{messages['Total Of Item']}</th>
            <th colSpan={5}></th>
        </tr>
        </tfoot>
      </table>
      </div>
    )
  }

  renderNewItemButton(){
    let {messages} = this.props
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
          </ButtonToolbar>       
        </Col>
      </Row>  
    )
  }

  
  renderStockStatus(){
    let {doc} = this.state
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>{this.props.messages['Stock Cut']}</span>)
    }else{
      return (<span/>)
    }
  }

  onTextChange(key,e) {
    let {doc,validDoc} = this.state

    if (doc==='')
      doc = this.getEmptyDoc()

    if (key==='request_by') {
      validDoc.request_by.formValid = null
      validDoc.request_by.validState = null
      this.setState({validDoc:validDoc})
    }

    if (key==='response_by') {
      validDoc.response_by.formValid = null
      validDoc.response_by.validState = null
      this.setState({validDoc:validDoc})
    }

    doc[key] = e.target.value
    this.setState({doc:doc})
    if (key==='car_registration_no') {
      this.loadCarRegistrationNo(doc)
      if(e.target.value==='')
        this.setState({car_info:''})
    }
  }

  onTextSelect(key, e) { 
    let {doc,car_registration_no_list,validDoc} = this.state

    if (doc==='')
      doc = this.getEmptyDoc()
    
    if (key=='car_registration_no') {
      let value = ''
      let car_info = ''
      
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          value = item.id
          car_info = item.car_info
          doc.work_no =  item.work_no
        }  
      })

      doc[key] = value
      this.setState({doc:doc,car_info:car_info})
      // this._description.focus()
    } else {

      if (key==='request_by') {
        validDoc.request_by.formValid = null
        validDoc.request_by.validState = null
        this.setState({validDoc:validDoc})
      }

      if (key==='response_by') {
        validDoc.response_by.formValid = null
        validDoc.response_by.validState = null
        this.setState({validDoc:validDoc})
      }

      doc[key] =  e
      this.setState({doc:doc})

      if (key=='request_by')
        this.refs._response_by.onFocus()
      // else if (key=='response_by')
      //   this._description.focus()
    }
  }

  onEmpTextKeyPress(key,e) {
    if (e.charCode === 13) {
      e.preventDefault()
      let {messages} = this.props
      let {customerList,doc} = this.state
      let checkSearch = false
      // let value = ''
      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          // value = item.id
        }
      })
      
      if (checkSearch) {
        if (key==='request_by')
          this.refs._response_by.onFocus()
        // else if (key=='response_by')
        //   this._description.focus()
      } else { 
        doc[key] = ''

        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }  
      this.setState({doc:doc})
    }  
  }

  onSupplierPageSelect(item){
    let {doc} = this.state
    doc['shop_id'] = item.shop_id
    doc['shop_name'] = item.name
    this.setState({doc:doc})
  }

  renderHeadTable() {
    let {doc,customerList,validDoc} = this.state
    let {messages} = this.props
    return(
            <Form>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Document Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder={'<'+messages['Auto Generated Number']+'>'} value={doc.mixpaint_no} className="input-dark" />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Date Picking up']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={this.getToday()}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['BU']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl value={doc.bu_name!==null?doc.bu_name:''} onChange={this.onTextChange.bind(this, 'bu_name')} />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Desired Date']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                  <DatePicker 
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={doc.desired_date}
                        onChange={this.onDesiredDateChange.bind(this)}
                        maxWidth={'100%'}
                  />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={validDoc.request_by.formValid}
                    validationState={validDoc.request_by.validState}
                  >
                    <ControlLabel>{messages['Requester']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={validDoc.request_by.formValid}
                    validationState={validDoc.request_by.validState}
                  >
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.request_by}
                          onChange={this.onTextChange.bind(this, 'request_by')}
                          onSelect={this.onTextSelect.bind(this, 'request_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'request_by')}
                          ref='_request_by'
                        />
                  </FormGroup>
                </Col>  
                <Col md={2}>
                  <FormGroup
                    controlId={validDoc.response_by.formValid}
                    validationState={validDoc.response_by.validState}
                  >
                    <ControlLabel>{messages['Approvers']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={validDoc.response_by.formValid}
                    validationState={validDoc.response_by.validState}
                  >
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.response_by}
                          onChange={this.onTextChange.bind(this, 'response_by')}
                          onSelect={this.onTextSelect.bind(this, 'response_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'response_by')}
                          ref='_response_by'
                        />
                  </FormGroup>
                </Col>
              </Row>
              <Row >
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Purchaser']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={doc.purchase_order_by} onChange={this.onTextChange.bind(this, 'purchase_order_by')} />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Shop']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Addon><FontAwesome name='user' /></InputGroup.Addon>
                      <FormControl value={doc.shop_name} onChange={this.onTextChange.bind(this, 'shop_name')} />
                      <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwesome name='plus' /></InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              <Row>                
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Description']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl inputRef={(input) => { this._description = input }} type="text" placeholder="" value={doc.description} onChange={this.onHeadInputChagne.bind(this,'description')} />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
    )
  }

  renderPaging(){
    let {messages} = this.props
    return (
      <div>
          <div className="text-right">
            <Pagination
              prev={messages['Previous']}
              next={messages['Next']}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this)}
            />
          </div>
        </div>
    )
  }

  render(){
    let {loading,stockShow,clearShow,doc,pullStockShow} = this.state
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }
    let {show,messages}  = this.props
    return (
      <div style={{display:show?'block':'none'}}>
        <Box loading={loading}>
          <Box.Header  className='text-center'>
            <Box.Title>
              {this.props.title}
            </Box.Title>
            <Box.Tools >
              
              <ButtonToolbar >                                            
                  <Button                             
                  bsStyle={'link'} className={'bg-maroon ' +(doc.recordid!==''?'':'hide')}
                  onClick={this.onPrintClick.bind(this)}
                >
                  <FontAwesome name='print'/>&nbsp;{messages['Print Document']}
                </Button>
              </ButtonToolbar>                     
            </Box.Tools> 
          </Box.Header>
          <Box.Body>
            <div className='stock-request'>
              {this.renderHeadTable()}
              {this.renderTable()}
              {this.renderNewItemButton()} 
            </div>
            <IframeModal ref='iframe' title={messages['Print Document']} />
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ConfirmPopup show={stockShow} 
              title={messages['Confirm Title']} 
              message={messages['Want To Update The Stock From This Item']}
              confirmTitle={messages['Confirm']} 
              onConfirm={this.onConfirmStockSave.bind(this)}
              onHide={()=>{this.setState({stockShow:false})}}        
              /> 
            <ConfirmPopup show={clearShow} 
              title={messages['Confirm Title']} 
              message={messages['Want To Start New Stock']}
              confirmTitle={messages['Confirm']} 
              onConfirm={this.onConfirmStockClear.bind(this)}
              onHide={()=>{this.setState({clearShow:false})}}        
              /> 
            <PullStock
              show={pullStockShow}
              onHide={this.onHideClick.bind(this)}
              stockType={this.props.stockType}
              onDataChange={this.onDataChange.bind(this)}
            />     
            <SupplierPageModal show={this.state.showSupplier} onHide={()=>{this.setState({showSupplier:false})}}
              onSelect={this.onSupplierPageSelect.bind(this)}
            /> 
          </Box.Body>    
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              <Button style={{display:doc.recordid!==''?'none':''}} bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='shopping-cart' />&nbsp;{messages['Request PO']}</Button>              
              <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
            </ButtonToolbar>
          </Box.Footer>    
        </Box>        
      </div>
    )
  }
}

StockRequestDoc.defaultProps = {
  show:false,
  showHead: true,
  openInoutPrintAfterSubmit:true,
  title: 'รายการเบิกแม่สีผสม'
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockRequestDoc}),null,null,{withRef:true},
)(StockRequestDoc);



// WEBPACK FOOTER //
// ./src/view/stock/StockRequestDoc.js